// removed by extract-text-webpack-plugin
module.exports = {"popwrap":"Popup-L1Verification-popwrap","button":"Popup-L1Verification-button","bookingTitle":"Popup-L1Verification-bookingTitle","bookingMainNormal":"Popup-L1Verification-bookingMainNormal","bookingFooter":"Popup-L1Verification-bookingFooter","bookingFooterRow":"Popup-L1Verification-bookingFooterRow","booksentloadsmartWarp":"Popup-L1Verification-booksentloadsmartWarp","strongFont":"Popup-L1Verification-strongFont"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/L1Verification/index.css
// module id = 1730
// module chunks = 0